import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "common-header" }
const _hoisted_2 = { class: "nav-row" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "name-area" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "name-text" }
const _hoisted_7 = { class: "header-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.hideBack)
        ? (_openBlock(), _createElementBlock("svg", {
            key: 0,
            width: "34",
            height: "34",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            class: "back-button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack(_ctx.back)))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("path", {
              d: "M13 5.5L6 12L13 18.5",
              stroke: "currentColor",
              "stroke-width": "1.8",
              "stroke-linecap": "round"
            }, null, -1)
          ])))
        : (_openBlock(), _createElementBlock("div", _hoisted_3)),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.data.icon)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.data.icon,
              class: "name-image"
            }, null, 8, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.data.name ? _ctx.$t(_ctx.data.name) : _ctx.data.name), 1)
      ]),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "header-right" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "bottom")
    ])
  ]))
}